import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import LedgerTable from '../../../../components/Tables/Warren/MachineLedgers';

import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome, FaFileExcel } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';

const SIMaintenanceOEM = () => {
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Machine Ledgers</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Machine Ledgers" className="mb-3 maintenance-element">
								<Tab eventKey="Machine Ledgers" title="Machine Ledgers">
									<h2>MACHINE LEDGERS</h2>
									<p>Maintenance information for the OEM equipment can be found in the documentation provided by the equipment manufacturer. The following table list the document and lists the section and where the maintenance information can be located.</p>
									<LedgerTable tablesorter={true} />
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceOEM;
